<template>
  <transition name="fade">
    <div v-if="isShowing">
      <div :id="modalType" class="modal fade show clear-margin" tabindex="-1" role="dialog" aria-modal="true">
        <div
          class="modal-dialog modal-dialog-centered"
          :class="[modalSize, { 'modal-dialog-scrollable': isScrollable === true }]"
        >
          <div class="modal-content position-relative" :class="backgroundColor">
            <div v-if="isHeaderOn" class="modal-header" :class="[headerColor, headerClass]">
              <slot name="header" />
              <h5 v-if="title" class="modal-title font-normal" id="primary-header-modalLabel" :class="titleClass">
                {{ title }}
              </h5>
              <button
                v-if="isClosable"
                type="button"
                class="close border-0 bg-transparent"
                :class="closeButtonClass"
                @click="$emit('close')"
              >
                <i class="mdi mdi-close icon-close py-0" :class="textColor" />
              </button>
            </div>
            <div class="modal-body" :class="modalBodyClass">
              <slot name="body" />
            </div>
            <div class="modal-footer" :class="footerClass" v-if="$slots['footer']">
              <slot name="footer" />
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal-backdrop fade show" />
    </div>
  </transition>
</template>

<script setup>
import { computed, watch } from 'vue'

const props = defineProps({
  type: {
    type: String,
    required: false,
    default: 'primary'
  },
  title: {
    type: String
  },
  isShowing: {
    type: Boolean,
    required: false,
    default: false
  },
  coloredHeader: {
    type: Boolean,
    required: false,
    default: false
  },
  headerClass: {
    type: String,
    required: false,
    default: ''
  },
  modalSize: {
    type: String,
    required: false,
    default: ''
  },
  modalBodyClass: {
    type: String,
    required: false,
    default: ''
  },
  isHeaderOn: {
    type: Boolean,
    required: false,
    default: true
  },
  isClosable: {
    type: Boolean,
    required: false,
    default: true
  },
  footerClass: {
    type: String
  },
  textColor: {
    type: String,
    default: 'text-muted',
    requred: false
  },
  closeButtonClass: {
    type: String,
    default: '',
    required: false
  },
  titleClass: {
    type: String,
    default: '',
    required: false
  },
  isScrollable: {
    type: Boolean,
    default: false,
    required: false
  }
})

const modalType = computed(() => `${props.type}-header-modal`)

const backgroundColor = computed(() => {
  if (props.coloredHeader) {
    return ''
  }
  if (props.type === 'success' || props.type === 'danger') {
    return `bg-${props.type} modal-filled`
  } else {
    return ``
  }
})

const headerColor = computed(() => {
  if (!props.coloredHeader) {
    return ''
  }

  if (props.type === 'success' || props.type === 'danger' || props.type === 'indigo' || props.type === 'info') {
    return `bg-${props.type} modal-colored-header`
  } else {
    return ''
  }
})

const toggleBodyClass = (method, bodyClass) => {
  const el = document.body

  if (method === 'add') {
    el.classList.add(bodyClass)
  } else {
    el.classList.remove(bodyClass)
  }
}

watch(
  () => props.isShowing,
  newValue => {
    if (newValue === true) {
      toggleBodyClass('add', 'modal-open')
    } else {
      toggleBodyClass('remove', 'modal-open')
    }
  }
)
</script>

<style lang="scss" scoped>
.modal {
  &.show {
    display: block;
  }

  .close {
    position: absolute;
    top: 10px;
    right: 11px;

    i {
      font-size: 21.336px;
    }
  }
  .modal-header {
    justify-content: space-between;
  }
  .modal-footer {
    margin-bottom: 20px !important;
  }
}

.text-indigo {
  color: $text-bg-info-light;
}
</style>
